import _ from 'lodash';
import {
    FETCH_LEDMODULE,
    FETCH_LEDMODULES,
    RESET_LEDMODULES,
} from '../actions/types';

const INITIAL_STATE: Object = null;

export default (state: Object = INITIAL_STATE, action: Object): Object => {
    switch (action.type) {
        case FETCH_LEDMODULES:
            // overwrite the entire state
            for (var i=0;i<action.payload.length;i++) {
                action.payload[i].order = i; 
            }
            const p = { ..._.mapKeys(action.payload, 'id')};
            delete p[1];
            return p;
        case FETCH_LEDMODULE:
            return { ...state, [action.payload.id]: action.payload };
        case RESET_LEDMODULES:
            return INITIAL_STATE;
        default:
            return state;
    }
};